export const BrandLockup = ({ dark = true }) => (
    <span className="flex items-center gap-3">
        <img
            src="/images/ihcc-logo.png"
            alt="IHCC official lantern logo"
            className="h-12 w-auto"
        />
        <span className="leading-tight">
            <span
                className={`block font-serif text-sm font-semibold tracking-wide md:text-base ${
                    dark ? "text-heritage-parchment" : "text-heritage-ink"
                }`}
            >
                Indian Heritage Gallery and Cultural Centre (IHCC)
            </span>
            <span
                className={`mt-0.5 block max-w-[300px] font-mono text-[8px] uppercase leading-relaxed tracking-[0.14em] ${
                    dark ? "text-heritage-gold" : "text-heritage-terra"
                }`}
            >
                Indian Heritage Museum and Cultural Attraction in Georgetown, Penang
            </span>
        </span>
    </span>
);
